import React, { memo, useEffect } from "react";
import { useMemo } from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";
import { Container } from ".";
import { useAuth } from "../../core";
import { Authentication } from "../pages";
import InvalidToken from "../pages/InvalidToken";
import { LoadingPage } from "../pages/LoadingPage";
import { ChatWidget } from "../widget";
import { NoLoginContainer } from "./NoLoignContainer";

const Route = memo(() => {
  const { user, tokenLogin, loadingToken, signout } = useAuth();
  const [urlToken] = useQueryParam("token", StringParam);
  const history = useHistory();
  useEffect(() => {
    if (urlToken) {
      try {
        signout(history);
        tokenLogin(urlToken);
      } catch (error) { }
    }
  }, [urlToken]);

  const getTokenBasedComponent = useMemo(() => {
    if (user?.loggedIn) {
      return <Container urlToken={user.accessToken} />;
    } else {
      return <InvalidToken />;
    }
  }, [user]);

  return (
    <Router
      basename={
        process.env.REACT_APP_PROJECT === "widget" ? "iframeWidgetNew" : ""
      }
    >
      {!urlToken ? (
        process.env.REACT_APP_LOGIN === "false" ? (
          <NoLoginContainer />
        ) : user?.loggedIn ? (
          <Container />
        ) : (
          process.env.REACT_APP_ONLY_URL_TOKEN === 'false' ? <Authentication /> : <InvalidToken />
          // <Authentication />
        )
      ) : (
        <>{loadingToken ? <LoadingPage /> : getTokenBasedComponent}</>
      )}
    </Router>
  );
});

const AppRoute = memo(() => {
  return (
    <>
      {process.env.REACT_APP_PROJECT === "chatbot" ? <Route /> : <ChatWidget />}
    </>
  );
});

export { AppRoute };
